<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-clock" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.tempo_medio_classificacao }} Minuto(s)
              </h2>
              <span>Tempo Médio de Espera</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-clock" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.tempo_medio_atendimento }} Minuto(s)
              </h2>
              <span>Tempo Médio de Atendimento</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-stethoscope" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.atendimentos }}
              </h2>
              <span>Atendimentos Recebidos</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-stethoscope" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.atendimentos_fila }}
              </h2>
              <span>Atendimentos Na Fila</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-stethoscope" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.atendimentos_finalizados }}
              </h2>
              <span>Atendimentos Finalizados</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-stethoscope" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.atendimentos_cancelados }}
              </h2>
              <span>Atendimentos Cancelados</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-primary`" size="45">
              <feather-icon size="21" :icon="'UsersIcon'" />
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.users }}
              </h2>
              <span>Usuários Cadastrados</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-warning`" size="45">
              <i class="fas fa-building" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.companies }}
              </h2>
              <span>Empresas Cadastradas</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-success`" size="45">
              <feather-icon size="21" :icon="'TagIcon'" />
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.specialties }}
              </h2>
              <span>Especialidades Cadastradas</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <feather-icon size="21" :icon="'ArchiveIcon'" />
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.setores }}
              </h2>
              <span>Setores Cadastrados</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-stethoscope" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.protocols }}
              </h2>
              <span>Protocolos Cadastrados</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <div class="col-md-3">
        <b-card no-body>
          <b-card-body class="pb-0">
            <b-avatar class="mb-1" :variant="`light-danger`" size="45">
              <i class="fas fa-stethoscope" style="font-size: 18px"></i>
            </b-avatar>
            <div class="truncate mb-2">
              <h2 class="mb-25 font-weight-bolder">
                {{ dashboard.highlights.flowchart }}
              </h2>
              <span>Fluxogramas Cadastrados</span>
            </div>
          </b-card-body>
        </b-card>
      </div>
      <b-modal
        v-model="showModal"
        centered
        title="Selecione a Empresa"
        no-close-on-backdrop
        no-close-on-esc
      >
        <div>
          <ul class="list-unstyled mt-1">
            <li
              v-for="item in companiesList"
              :key="item.id"
              class="p-3 mb-3 border rounded shadow-sm d-flex justify-content-between align-items-center company-item"
            >
              <div>
                <span class="font-weight-bold text-primary">
                  {{ item.company ? item.company.fantasy_name : "" }}
                </span>
                <br />
                <small class="text-muted">
                  CNPJ: {{ item.company ? item.company.cnpj : "" }}
                </small>
              </div>
              <b-button
                variant="success"
                size="sm"
                class="ml-3 choose-btn"
                @click="chooseCompany(item.company_id)"
              >
                <i class="fas fa-check mr-1"></i> Escolher
              </b-button>
            </li>
          </ul>
        </div>

        <template #modal-footer>
          <b-button variant="secondary" @click="closeModal">
            Continuar na empresa atual
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { BCardText, BLink, BModal, BButton } from "bootstrap-vue";
import Cookies from "js-cookie";
import { BCard, BCardBody, BAvatar } from "bootstrap-vue";

export default {
  data() {
    return {
      dashboard: {
        highlights: {
          users: 0,
          companies: 0,
          specialties: 0,
          setores: 0,
          flowchart: 0,
          atendimentos_finalizados: 0,
          atendimentos_fila: 0,
          atendimentos: 0,
          protocols: 0,
          tempo_medio_classificacao: 0,
          tempo_medio_atendimento: 0,
        },
      },
      showModal: false,
      companiesList: [],
    };
  },
  components: {
    BCard,
    BCardText,
    BLink,
    BCard,
    BCardBody,
    BAvatar,
    BModal,
    BButton,
    Cookies,
  },
  methods: {
    getDashboard() {
      const api = this.$store.state.api + "dashboard";
      axios
        .post(api)
        .then((response) => {
          this.dashboard = response.data;
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    getVerify() {
      const api = this.$store.state.api + "verifiy_professional_companies";
      axios
        .get(api)
        .then((response) => {
          this.companiesList = response.data;

          const cookie = Cookies.get("modalCompanyChosen");

          if (
            !cookie &&
            this.companiesList.length > 1 &&
            this.$store.state.user.access_nivel == 1
          ) {
            this.showModal = true;
          }
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    chooseCompany(companyId) {
      const api = this.$store.state.api + "change_company";
      axios
        .post(api, { company_id: companyId })
        .then(() => {
          this.$message("Sucesso", "Empresa alterada com sucesso!", "success");
          Cookies.set("modalCompanyChosen", "true", { expires: 1 });
          this.closeModal();
          window.location.reload();
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    closeModal() {
      this.showModal = false;
      Cookies.set("modalCompanyChosen", "true", { expires: 1 });
    },
  },
  mounted() {
    this.getDashboard();
    this.getVerify();
  },
  created() {},
};
</script>

<style>
.company-item {
  transition: all 0.2s ease-in-out;
}
.company-item:hover {
  background-color: #f8f9fa;
  transform: scale(1.02);
}
.choose-btn {
  transition: background-color 0.2s ease-in-out, transform 0.1s ease-in-out;
}
.choose-btn:hover {
  background-color: #28a745 !important;
  transform: scale(1.05);
}
</style>
